export default __webpack_public_path__ + "static/media/connecting-image .1d276c5d.png";